angular.module('Directives').controller('PercentageDisplayController',['$scope', function($scope) {
    const vm = this;

    vm.$onInit = function() {
        vm.colorThreshold = vm.colorThreshold || 5000;
        vm.lowerBound = vm.lowerBound || -100;
        vm.upperBound = vm.upperBound || 5000;
        vm.runDown = vm.runDown || false;
        vm.isAllocHoldings = vm.isAllocHoldings || false;
    };

    vm.isHighPerformance = function() {
        return vm.percentValue * 100 >= vm.upperBound || vm.percentValue * 100 <= vm.lowerBound;
    };

    vm.displayPercent = function() {
        if (vm.isHighPerformance()) {
            return '— —';
        }
        return (vm.percentValue * 100).toFixed(2) || '0.00';
    };

    $scope.dispatchChatBox = function() {
        document.dispatchEvent(
            new CustomEvent('_chat-box', {
                detail: {
                    openChatBox: true,
                },
            })
        );
    };

}]);